module.exports = __webpack_public_path__ + "img/proImg5.a50d35e4.png";